import { Box, HStack, Header, Pressable } from '@rbilabs/universal-components';

import { getDesignToken, primitive, spacing } from 'styles/constants';
export const ProductCustomizationPanel = Box.withConfig({
  height: 'full',
  width: 'full',
  alignSelf: 'center',
});

export const GroupsCustomizationModifiersContainer = Box.withConfig({
  width: 'full',
  margin: 0,
  padding: 0,
});

export const ModifiersCustomizationContainer = Box.withConfig({
  width: 'full',
  paddingX: '$2',
  paddingY: '$4',
  backgroundColor: primitive.$blackOpacity4,
  marginY: '$4',
  borderRadius: primitive.$borderRadius,
});

export const DrinksTabLink = Pressable.withConfig<{ active: boolean }>(({ active }) => ({
  flexGrow: 1,
  isUnderlined: false,
  margin: 0,
  fontFamily: 'body',
  textAlign: 'center',
  textTransform: 'none',
  maxWidth: 'full',
  borderBottomWidth: active ? 2 : 0,
  borderBottomColor: active ? getDesignToken('color-tertiary') : 'transparent',
  paddingX: 2,
  justifyContent: 'center',
  alignItems: 'center',

  _focus: {
    borderBottomColor: {
      base: active ? getDesignToken('color-tertiary') : 'transparent',
      md: active ? primitive.$bbqBrown : 'transparent',
    },
  },

  _text: {
    marginBottom: {
      md: 0,
    },
  },
}));

export const DrinksTabLinkText = Header.withConfig<{ active?: boolean }>(({ active }) => ({
  color: active ? getDesignToken('color-tertiary') : getDesignToken('color-tertiary'),
  fontFamily: active ? 'heading' : 'body',
  marginTop: 0,
  fontSize: { md: 'sm' },
  lineHeight: { md: 'md' },
  textTransform: 'capitalize',
}));

export const DrinksTabsWrapper = HStack.withConfig({
  position: 'relative',
  width: 'full',
  height: getDesignToken('layout-nav-height-mobile'),
  background: 'transparent',
  marginY: spacing.$0_5,
  paddingTop: '$2',
  paddingX: 0,
});

export const DrinksTabsContent = Box.withConfig({
  marginTop: { base: '$6', md: '$8' },
});
